import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "settlement-detail-btn"
};
const _hoisted_2 = {
  class: "contract-list-btn"
};
import { onMounted, reactive, ref } from "vue";
import apis from "@/api";
import { ElMessage } from "element-plus";
import ContractStatus from './ContractStatus';
import StatementStatus from './StatementStatus';
import ContractSettlementDetail from './ContractSettlementDetail';
import ContractSettlementAdd from './ContractSettlementAdd';
import download from "@/utils/download";
import ContractSettlementEdit from "./ContractSettlementEdit.vue";
import common from "@/views/Home/MyNeeds/composables/common";
import { USERINFO } from "@/store/mutation-types";
export default {
  __name: 'ContractSettlement',
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    contract: {
      type: Object
    },
    contractAction: {
      type: String
    },
    provinceAction: {
      type: Boolean,
      default: false
    },
    adminArea: {
      type: String
    }
  },
  emits: ['submit'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      exportContractWord,
      exportContractPdf
    } = download();
    const emits = __emit;
    const detailVisible = ref(false);
    const editVisible = ref(false);
    const addVisible = ref(false);
    const isAudit = ref(false);
    const isAccount = ref(false);
    const actionName = ref(''); // 动作名称

    const detailLoading = ref(false);
    const detailRef = ref();
    const editRef = ref();
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const userInfo = ref({});
    const props = __props;
    const data = reactive({
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      audit: {
        settlementState: 0,
        auditDescription: null
      },
      currentDetail: {}
    });
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    const loadData = () => {
      isAccount.value = false;
      userInfo.value = JSON.parse(window.localStorage.getItem(USERINFO));
      const params = {
        contractId: props.contract.id,
        ...data.pagination,
        adminArea: props.isAdmin ? props.adminArea : ''
      };
      detailLoading.value = true;
      apis.getContractDetailedList(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        detailLoading.value = false;
      });
    };
    const handleView = row => {
      isAudit.value = false;
      isAccount.value = false;
      actionName.value = 'handleView';
      data.currentDetail = row;
      detailRef.value.DetailedSettlementList(row);
      detailRef.value.loadDataDetailedSettlementTag(row);
      detailRef.value.loadDataDetailedSettlementAccessoryTag(row);
      detailRef.value.loadAccountTag(row);
      detailRef.value.loadComparison(row);
      detailVisible.value = true;
    };
    const handleEdit = row => {
      isAudit.value = false;
      isAccount.value = false;
      actionName.value = 'handleEdit';
      data.currentDetail = row;
      editRef.value.DetailedSettlementList(row);
      editRef.value.loadDataDetailedSettlementTag(row);
      editRef.value.loadDataDetailedSettlementAccessoryTag(row);
      detailRef.value.loadAccountTag(row);
      editVisible.value = true;
    };
    const handleDelete = row => {
      ElMessageBox.confirm('确定要撤回该结算单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        apis.deleteContractDetailed(row.id).then(res => {
          if (res.success) {
            ElMessage.success("撤回成功！");
            loadData();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }).catch(() => {
        loadData();
      });
    };
    const handleAudit = row => {
      isAudit.value = true;
      isAccount.value = false;
      actionName.value = 'handleAudit';
      data.currentDetail = row;
      detailRef.value.DetailedSettlementList(row);
      detailRef.value.loadDataDetailedSettlementTag(row);
      detailRef.value.loadDataDetailedSettlementAccessoryTag(row);
      detailRef.value.loadComparison(row);
      detailVisible.value = true;
    };
    const handleAccount = row => {
      isAudit.value = false;
      isAccount.value = true;
      actionName.value = 'handleAccount';
      data.currentDetail = row;
      detailRef.value.DetailedSettlementList(row);
      detailRef.value.loadDataDetailedSettlementTag(row);
      detailRef.value.loadDataDetailedSettlementAccessoryTag(row);
      detailRef.value.loadAccountTag(row);
      detailRef.value.loadComparison(row);
      detailVisible.value = true;
    };
    const handleRecord = row => {
      isAudit.value = false;
      isAccount.value = false;
      actionName.value = 'handleRecord';
      data.currentDetail = row;
      detailRef.value.DetailedSettlementList(row);
      detailRef.value.loadDataDetailedSettlementTag(row);
      detailRef.value.loadAccountTag(row);
      detailRef.value.loadDataDetailedSettlementAccessoryTag(row);
      detailVisible.value = true;
    };
    const handleSettlementAdd = () => {
      addVisible.value = true;
    };
    const handleWord = row => {
      detailLoading.value = true;
      const fileName = row.contractName + "_" + row.statementName + "_" + row.statementCode + ".docx";
      exportContractWord(row.id, fileName).then(() => {
        detailLoading.value = false;
      }).finally(() => {
        detailLoading.value = false;
      });
    };
    const handlePdf = row => {
      detailLoading.value = true;
      const fileName = row.contractName + "_" + row.statementName + "_" + row.statementCode + ".pdf";
      exportContractPdf(row.id, fileName).then(() => {
        detailLoading.value = false;
      }).finally(() => {
        detailLoading.value = false;
      });
    };
    onMounted(() => {
      loadData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [__props.contractAction === 'settlementAdd' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        onClick: handleSettlementAdd
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("新增结算单 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        border: "",
        data: data.tableData,
        style: {
          "width": "100%"
        },
        "header-cell-style": headerStyle.value
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "statementCode",
          label: "结算单编号"
        }), _createVNode(_component_el_table_column, {
          prop: "statementName",
          label: "结算单名称"
        }), _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "true",
          prop: "createDate",
          label: "创建日期"
        }), _createVNode(_component_el_table_column, {
          prop: "settlementDescription",
          label: "结算说明"
        }), _createVNode(_component_el_table_column, {
          prop: "currentSettlementAmount",
          label: "本次结算金额"
        }), _createVNode(_component_el_table_column, {
          prop: "settlementPersonnelName",
          label: "合同管理员"
        }), _createVNode(_component_el_table_column, {
          prop: "examinePerson",
          label: "审核人"
        }), _createVNode(_component_el_table_column, {
          prop: "examineDate",
          label: "审核时间"
        }), _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "true",
          prop: "examineOpinion",
          label: "审核意见"
        }), _createVNode(_component_el_table_column, {
          prop: "statementArea",
          label: "结算单地区"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(_unref(common)().getAreaByCode(scope.row.statementArea)), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "examineState",
          label: "结算单状态"
        }, {
          default: _withCtx(scope => [!__props.isAdmin ? (_openBlock(), _createBlock(_unref(ContractStatus), {
            key: 0,
            "settlement-state": scope.row.examineState
          }, null, 8, ["settlement-state"])) : _createCommentVNode("", true), __props.isAdmin ? (_openBlock(), _createBlock(_unref(StatementStatus), {
            key: 1,
            "statement-state": scope.row.examineState
          }, null, 8, ["statement-state"])) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleView(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("查看明细", -1)]))]),
            _: 1
          }, 8, ["onClick"])]), _createElementVNode("div", null, [!__props.isAdmin && scope.row.examineState === 1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleEdit(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("编辑", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [!__props.isAdmin && scope.row.examineState === 1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleDelete(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("删除", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [!__props.isAdmin && scope.row.examineState === 2 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleDelete(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("撤回", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [!__props.isAdmin && scope.row.examineState === 0 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleAccount(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("报账", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.isAdmin && scope.row.examineState === 2 && __props.provinceAction && __props.adminArea === scope.row.statementArea && (!scope.row.settlementPersonnel || scope.row.settlementPersonnel === userInfo.value.userId) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleAudit(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("审核 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.isAdmin && scope.row.examineState === 4 && __props.provinceAction && __props.adminArea === scope.row.statementArea ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleRecord(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("发起归档 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.isAdmin && (scope.row.examineState === 4 || scope.row.examineState === 0 || scope.row.examineState === 9) && __props.provinceAction && __props.adminArea === scope.row.statementArea ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleWord(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("导出Word ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [(scope.row.examineState === 4 || scope.row.examineState === 0 || scope.row.examineState === 9) && __props.provinceAction ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handlePdf(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("导出PDF ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "header-cell-style"])), [[_directive_loading, detailLoading.value]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "page-sizes": [10, 20, 50, 100, 200],
        "page-size": data.pagination.pageSize,
        total: data.pagination.totalSize,
        currentPage: data.pagination.pageNo,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => data.pagination.pageNo = $event),
        layout: "total, prev, pager, next, sizes, jumper"
      }, null, 8, ["page-size", "total", "currentPage"])]), _createVNode(_unref(ContractSettlementDetail), {
        visible: detailVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => detailVisible.value = $event),
        detail: data.currentDetail,
        contract: __props.contract,
        "is-audit": isAudit.value,
        "is-account": isAccount.value,
        "is-admin": __props.isAdmin,
        "action-name": actionName.value,
        onSubmit: loadData,
        ref_key: "detailRef",
        ref: detailRef
      }, null, 8, ["visible", "detail", "contract", "is-audit", "is-account", "is-admin", "action-name"]), _createVNode(ContractSettlementEdit, {
        visible: editVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = $event => editVisible.value = $event),
        detail: data.currentDetail,
        "is-audit": isAudit.value,
        "is-admin": __props.isAdmin,
        contract: __props.contract,
        "action-name": actionName.value,
        onSubmit: loadData,
        ref_key: "editRef",
        ref: editRef
      }, null, 8, ["visible", "detail", "is-audit", "is-admin", "contract", "action-name"]), _createVNode(_unref(ContractSettlementAdd), {
        visible: addVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => addVisible.value = $event),
        "contract-id": __props.contract.id,
        contract: __props.contract,
        onSubmit: loadData
      }, null, 8, ["visible", "contract-id", "contract"])], 64);
    };
  }
};